import {
  collection,
  getDocs,
  query,
  addDoc,
  orderBy,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { toast } from "react-toastify";
import { db } from ".";

// Function to add data to firebase users/{user}/piggy collection
const addRecord = async (source, amount, isIncrease, date, uid) => {
  const data = {
    source: source,
    amount: amount,
    status: isIncrease ? "increase" : "decrease",
    date: date,
  };

  await addDoc(collection(db, `users/${uid}/piggy`), data)
    .then((docRef) => {
      toast.success("Data added successfully");
      data["id"] = docRef.id;
    })
    .catch(() => toast.error("Unable to add data"));

  return data;
};

// Function to fetch all documents from users/{user}/piggy collection
const fetchPiggy = async (uid) => {
  const results = [];
  const querySnapshot = await getDocs(
    query(collection(db, `users/${uid}/piggy`), orderBy("date", "desc"))
  );

  querySnapshot.forEach((doc) => {
    const docObj = doc.data();
    docObj["id"] = doc.id;
    results.push(docObj);
  });

  return results;
};

// Function to delete a documents from users/{user}/piggy collection
const delRecord = async (docid, uid) => {
  await deleteDoc(doc(db, `users/${uid}/piggy`, docid))
    .then(() => toast.success("Record deleted successfully"))
    .catch(() => toast.error("Unable to delete"));
};

export { addRecord, delRecord, fetchPiggy };
